import spiderman from '@/spiderman/index';

async function send(member, survey) {
  return (
    await spiderman.axios.post(spiderman.api.satisfactionSurveys,
      survey,
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

export default {
  send,
};
